import { message } from "antd";
import * as EVENT from "./eventKeys";

export const generateFilterUrl = (filters) => {
    let mappings = {}, params = [], url = '';
    if (filters && Object.keys(filters)?.length > 0) {
        Object.keys(filters)
            .map(filterKey => {
                if ((filters?.[filterKey] || filters?.[filterKey] === 0))
                    mappings = {...mappings, ...filters}
                else {
                    delete filters[filterKey]
                    mappings = {...filters}
                }
                if (Array.isArray(filters?.[filterKey])) {
                    if (filters?.[filterKey])
                        delete filters[filterKey]
                    mappings = {...filters}
                }
            })
        params = createQueryParamUrl(mappings).join("");
        url = params;
    }
    return url
}
export const createQueryParamUrl = (filterKeys) => {
    let params = []
    try {
        let filterKeysArray = Object.keys(filterKeys)
        filterKeysArray.map(((key, index) => {
            if (filterKeys[key] !== null) {
                params.push(`${key}=${filterKeys[key]}${index !== filterKeysArray?.length - 1 ? '&' : ''}`)
            }
        }));
    } catch (e) {

    }
    return params
}

export const getSourcePage = (path) =>{
    switch(path)
    {
        case 'Activities':
        case '/activities':
            return EVENT.SOURCE_PAGE_ACTIVITIES;
        case 'Leaderboard':
        case '/Leaderboard':
            return EVENT.SOURCE_LEADER_BOARD_PAGE;
        case '/collection/:id':
            return EVENT.SOURCE_PAGE_COLLECTION;
        case 'Stories':
        case '/story':
            return EVENT.SOURCE_STORY_READING;
        case 'Feed':
        case '/':
            return EVENT.SOURCE_FEED_PAGE;
        case 'Play':
        case '/quiz':
            return EVENT.SOURCE_PLAY_PAGE;
        case 'fLIVE':
        case '/user':
        case '/profile-complete':
        case '/student/profile':
            return EVENT.SOURCE_STUDENT_DASHBOARD_PAGE;
        default:
            return EVENT.SOURCE_FEED_PAGE;
    }
}

export const goBackToMainSite = () => {
  let parentOrigin = null;

   try {
     if (document.referrer) {
       parentOrigin = new URL(document.referrer).origin;
     }
   } catch (e) {
     console.warn("Invalid referrer URL:", document.referrer);
   }

  if (sessionStorage.getItem("parent_source") === "android"){
          window.AndroidInterface.navigateBack();
  }else if (window.parent !== window) {
      window.parent.postMessage({ type: "navigate-back" }, parentOrigin); // Send message to parent
    }
};

export const FinalExamsList = ['Baseline Assessment','Midline Assessment','Endline Assessment']

export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const getIROExamDurationMinutes = () =>
  sessionStorage.getItem("exam_section") === "Reading Comprehension" ? 30 : 40;

export const handleDirectSubmitAndRedirect = async (
  history,
  endIROTest,
  setIsSubmittingTest,
  setIsRedirecting
) => {
  try {
    if (setIsSubmittingTest) setIsSubmittingTest(true);
    await endIROTest({
      iro_test_id: sessionStorage.getItem("iro_test_id"),
      exam_section: sessionStorage.getItem("exam_section"),
    });
    // Wait for backend to process before navigating to results
    await delay(1500);
    
    if (setIsRedirecting) setIsRedirecting(true);
    history.replace(
      `${
        FinalExamsList.includes(sessionStorage.getItem("iro_test_name"))
          ? "/iro-feedback-form"
          : "/iro-view-report"
      }`
    );
  } catch (error) {
    console.error("Error during direct submit and redirect:", error);
    if (setIsSubmittingTest) setIsSubmittingTest(false);
    if (setIsRedirecting) setIsRedirecting(false);
    message.error("Something went wrong while submitting. Please check your connection and try again.", 5);
  }
};
